module.exports = __webpack_public_path__ + "static/media/logo-paiEterno2.51466697.png";